// Helpers
import { submitDeleteRequest, addToClients } from '../companyUsersHelpers'
import { openEditForm, closeEditForm, removeCompanyUser } from '../actions/companyUsers'

const DataDisplayRow = ({ isAgency, isAgencyAdmin, companyUser, companyUsersUrl, dispatch }) => {
  const user = companyUser.user
  return (
    <tr>
      <td className="company-user-user-name">{ `${user.first_name} ${user.last_name}` }</td>
      <td>{ user.email }</td>
      <td dangerouslySetInnerHTML={{ __html: companyUser.access_type_display }}></td>
      <td>{ companyUser.is_admin ? 'Yes' : 'No'}</td>
      {
        isAgency && <td className="is-agency-user">{companyUser.is_agency_user && 'Yes'}</td>
      }
      <td className="nowrap">
        <button onClick={e => dispatch(openEditForm(companyUser.id))} className="btn btn-default btn-sm edit-btn">Edit</button>&nbsp;
        {
          isAgencyAdmin &&
          companyUser.is_agency_user &&
          <span><button className="btn btn-sm btn-primary add-to-managed-companies-btn" onClick={e => {
            addToClients(e, companyUsersUrl, companyUser.id)
          }}>Add to Managed Companies</button>&nbsp;</span>
        }
        <button className="btn btn-sm btn-default btn-delete" onClick={e => {
          submitDeleteRequest(e, companyUsersUrl, companyUser.id, isAgencyAdmin && companyUser.is_agency_user,
            () => dispatch(removeCompanyUser(companyUser.id)))
        }}>Remove from Company</button>
      </td>
    </tr>
  )
}
const mapStateToProps = ({ isAgency, isAgencyAdmin, companyName, companyUsersUrl }) => ({
  isAgency,
  isAgencyAdmin,
  companyName,
  companyUsersUrl
})
export default connect(mapStateToProps)(DataDisplayRow)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/DataDisplayRow.js